import { GridBaseDataProvider } from '../../../grid/GridBaseDataProvider';
import { Column } from '@nirvana/shared/dtos/types/shared/filters';
import { GetRowsRequest, GetSummaryRequest, GetSummaryResponse } from '../../../grid/types/common';
import { convertGridFiltersToExtJsFilters } from '../../../grid/utils/filters';
import { ColumnKeys } from '../types';
import { handleComplexEnumFilter } from '../../common/utils';
import { Feature } from '@nirvana/shared/constants';

export class DevicesAppGridDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  response;
  dependencies;

  constructor(dependencies) {
    super();
    this.dependencies = dependencies;
  }

  async getSummary(request: GetSummaryRequest<ColumnKeys>): Promise<GetSummaryResponse> {
    let response = this.response;

    // if you change something here, change in handleCSVExportEvent in controller too
    let filters: any[] = convertGridFiltersToExtJsFilters(request.filters);
    const complexEnumFilterColumns = [
      ColumnKeys.DEVICE_NAME,
      ColumnKeys.REGION,
      ColumnKeys.DEVICE_FQDN,
      ColumnKeys.DEVICE_MACS,
      ColumnKeys.DEVICE_CVES,
      ColumnKeys.DEVICE_MISCONFIGURATIONS,
      ColumnKeys.DEVICE_IP,
      ColumnKeys.RESOURCE_ID,
      ColumnKeys.CLOUD_ACCOUNT,
      ...Application.Main.hasFeatures([Feature.PRODUCT_FEATURE_BCST_IMAGE_SCANNER_USABLE])
        ? [
            ColumnKeys.REPOSITORY_NAME,
            ColumnKeys.REGISTRY_HOST
          ]
        : [],
      ...Application.Main.hasFeatures([Feature.PRODUCT_FEATURE_KSPM_USABLE])
        ? [
            ColumnKeys.CLUSTER_NAME,
          ]
        : [],
    ];
    filters = handleComplexEnumFilter(complexEnumFilterColumns, filters);

    if (!response) {
      response = await this.dependencies.api.clients.RiskManagementDevices.readRecords(request, filters).toPromise();
      this.response = response;
    }

    const summary: any = {
      summary: `${response.total} items`,
      numItems: response.total,
    };

    if (response.extraDetails) {
      summary.extraDetails = response.extraDetails;
    }

    return summary;
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<any> {
    if (!this.response) {
      return { rawEvents: [] };
    }

    const response = this.response;
    this.response = null;
    return { rawEvents: response.data };
  }
}
